export class Event {
    Id: number;
    ContractId: number;
    Number: string;
    PersonId: number;
    PolicyHolder: string;
    EventDate: Date;
    EventTypeId: number;
    EventType: string;
    AgentId: number;
    IsViewed: boolean;
    ViewedByAgentId: number;
    Color: string;
}